import { ProductReceiptParams } from '@repo/accounts-types'
import { createDownloadSlice } from '@repo/core'

export const {
  actions: bankingProductLoanReceiptsDownloadActions,
  reducer: bankingProductLoanReceiptsDownloadReducer,
} = createDownloadSlice<ProductReceiptParams>(
  '@accounts/master/list/bankingProductLoanReceiptsDownload',
)
